export default [
    {
      path: '/rent/v2/apply-invoice',
      name: 'applyInvoice',
      component: () => import('@/pages/invoice/applyInvoice'),
      meta: { title: '申请开票', requireAuth: true },
    },
    {
      path: '/rent/v2/invoice-detail',
      name: 'invoiceDetail',
      component: () => import('@/pages/invoice/invoiceDetail'),
      meta: { title: '发票详情', requireAuth: true },
    },
  ]


// WEBPACK FOOTER //
// ./src/pages/invoice/invoice.js